import { TogglesState } from 'common/feature-togglings/reducer'
import { adBlockEnabled } from 'component-library/advertising/gpt/GptAdProvider/utils'
import { Features } from 'common/features'
import { SpaInitialisedEvent } from 'common/events/page-events'

/** This works with the event buffer, until this event, events will be buffered
 *
 * Once this event is raised it will be raised first, then any buffered events
 * will be raised after.
 */
export const createSpaInitialisedEvent = (toggles: TogglesState): SpaInitialisedEvent => {
    return {
        type: 'spa.initialised',
        originator: 'Features',
        payload: {
            enabledFeatures: getEnabledFeatures(toggles),
            adBlockEnabled: adBlockEnabled(),
        },
    }
}

function getEnabledFeatures(toggles: TogglesState) {
    return Object.keys(toggles.featureState).filter(key => {
        const feature = key as Features
        const clientOverride = toggles.userOverrides[feature]
        const featureState = toggles.featureState[feature]
        return !!clientOverride || (featureState && featureState.enabled)
    })
}
